import React from 'react'
import { BasicStatsItem } from '../index.styles'

const link = 'https://app.powerbi.com/view?r=eyJrIjoiYjFiNTY5OWYtZjI2YS00Y2ZiLWJiZGMtMTZiMjEzMDRlNTM0IiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'

const PsdDashboard = () => {
  return (
    <BasicStatsItem style={{
      width: '100%',
      height: '100%',
    }}>
      <iframe title="PSD iframe" src={link} />
    </BasicStatsItem>
  )
}

export default PsdDashboard